import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AlertsWithIconsTextActions } from "../../../../Constant";
import { ICON_TEXT_DATA } from "../../../../Data/UiKit/Alert";
import { Alerts, Btn, P } from "../../../../AbstractElements";
import { useState } from "react";

const AlertsWithIconsandTextActions = () => {
  const [visible, setVisible] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(true);
  const onDismiss = () => setVisible(false);
  const onDismissAlert = () => setVisibleAlert(false);

  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={AlertsWithIconsTextActions} span={ICON_TEXT_DATA} />
        <CardBody>
          <Alerts fade isOpen={visible} className="border-warning alert-dismissible p-0">
            <div className="alert-arrow bg-warning">
              <i className="icon-timer"></i>
            </div>
            <P>Your time Over after <strong className="txt-dark">5</strong> minute</P>
            <Btn className="p-0 border-0 me-2 ms-auto" onClick={onDismiss}><span className="bg-warning text-black px-3 py-1">Check</span></Btn>
          </Alerts>
          <Alerts fade isOpen={visibleAlert} className="border-danger alert-dismissible p-0 mb-0">
            <div className="alert-arrow bg-danger"><i className="icon-heart"></i></div>
            <P>Oh snap! Change a few things up <strong className="txt-dark"> Notification check</strong></P>
            <Btn className="p-0 border-0 me-2 ms-auto" onClick={onDismissAlert}><span className="bg-danger text-white px-3 py-1">Alert</span></Btn>
          </Alerts>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AlertsWithIconsandTextActions;
